import moment from "moment-jalaali";
import {
  useGetOrderCompareAreaChart,
  useGetOrderCompareCountChart,
} from "../../../../Production/OrderArchive/Hook";
import { useEffect, useState } from "react";

const useOrderCompareContainer = () => {
  const { mutate, data } = useGetOrderCompareCountChart();
    const [loading, setLoading] = useState(false);
  const { mutate: mutateArea, data: dataArea } = useGetOrderCompareAreaChart();
  const [lables, setlables] = useState({
    date1: "",
    date2: "",
    date3: "",
  });

  const [total, setTotal] = useState([
    {
      title: "",
      count: 0,
      color: "",
      key: "",
    },
  ]);

  const dateList = {
    date1: "",
    date2: "",
    date3: "",
  };

  /*================== Active Filter Type =================*/
  const [activeFilterType, setActiveFilterType] = useState(2);

  const changeActiveFilterType = () => {
    if (activeFilterType === 1) setActiveFilterType(2);
    if (activeFilterType === 2) setActiveFilterType(1);
    setLoading(true);
    
  };

  /*================== Submit Form =================*/

  const submitForm = (data) => {
    moment.loadPersian({ dialect: "persian-modern" });
    setlables({
      date1: moment(data.date1).format("jMMMM jYYYY"),
      date2: moment(data.date2).format("jMMMM jYYYY"),
      date3: moment(data.date3).format("jMMMM jYYYY"),
    });
    const dateList = [];
    if (data.date1) {
      let fristDate = moment(data.date1).locale("en").format("jYYYY/jMM");
      dateList.push(fristDate);
    }
    if (data.date2) {
      let secondDate = moment(data.date2).locale("en").format("jYYYY/jMM");
      dateList.push(secondDate);
    }
    if (data.date3) {
      let thirdDate = moment(data.date3).locale("en").format("jYYYY/jMM");
      dateList.push(thirdDate);
    }
    if (activeFilterType === 1) {
      mutate(dateList);
    } else {
      mutateArea(dateList);
    }
  };
  /*================== Clear DatePicker =================*/
  const clearDatePicker = (setField, key) => {
    setField(key, null);
  };
  useEffect(() => {
    if (data && activeFilterType === 1) {
      setTotal([
        {
          count: data?.data?.data?.total,
          color: "#3592FB",
          title: lables?.date1,
          key: "total_2_1",
        },
        {
          count: data?.data?.data?.total1,
          color: "rgba(154, 64, 224, 1)",
          title: lables?.date2,
          key: "total_2_2",
        },
        {
          count: data?.data?.data?.total2,
          color: "rgba(255, 152, 0, 1)",
          title: lables?.date3,
          key: "total_2_3",
        },
      ]);
    }
    if (dataArea && activeFilterType === 2) {
      setTotal([
        {
          count: dataArea?.data?.data?.total,
          color: "#3592FB",
          title: lables?.date1,
          key: "total_2_1",
        },
        {
          count: dataArea?.data?.data?.total1,
          color: "rgba(154, 64, 224, 1)",
          title: lables?.date2,
          key: "total_2_2",
        },
        {
          count: dataArea?.data?.data?.total2,
          color: "rgba(255, 152, 0, 1)",
          title: lables?.date3,
          key: "total_2_3",
        },
      ]);
    }
  }, [data, dataArea]);

  return {
    submitForm,
    data,
    dataArea,
    dateList,
    lables,
    activeFilterType,
    changeActiveFilterType,
    total,
    clearDatePicker,loading, setLoading
  };
};
export default useOrderCompareContainer;
